import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="container-x py-24 text-center max-w-xl mx-auto" data-testid="not-found-page">
      <p className="text-[8rem] font-light text-[#2B8B8E] leading-none mb-4">404</p>
      <h1 className="text-3xl font-semibold mb-3">Page introuvable</h1>
      <p className="text-muted-foreground mb-8">
        Cette page n'existe pas ou a été déplacée. Retournez à l'accueil ou consultez nos espaces disponibles.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Button asChild className="bg-[#2B8B8E] hover:bg-[#1F6F73] text-white rounded-full px-8" data-testid="back-home-btn">
          <Link to="/">Retour à l'accueil</Link>
        </Button>
        <Button asChild variant="outline" className="rounded-full px-8">
          <Link to="/reserver">Réserver un espace</Link>
        </Button>
      </div>
    </div>
  );
}
